import { LadderDirection } from '../../shared/ladder-limit-orders.util';

export const TOKEN_TICKET_LADDER_PREFERENCES_KEY =
  'kcc20.token-ticket.ladder.v1';

export interface TokenTicketLadderPreferences {
  expanded: boolean;
  direction: LadderDirection;
  percent: string;
}

export const DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES: TokenTicketLadderPreferences =
  {
    expanded: true,
    direction: 'decrement',
    percent: '1',
  };

export function readTokenTicketLadderPreferences(): TokenTicketLadderPreferences {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES };
  }
  try {
    const value = JSON.parse(
      window.localStorage.getItem(TOKEN_TICKET_LADDER_PREFERENCES_KEY) ||
        'null',
    ) as Partial<TokenTicketLadderPreferences> | null;
    return {
      expanded:
        typeof value?.expanded === 'boolean'
          ? value.expanded
          : DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES.expanded,
      direction:
        value?.direction === 'increment' || value?.direction === 'decrement'
          ? value.direction
          : DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES.direction,
      percent:
        typeof value?.percent === 'string' && value.percent.trim()
          ? value.percent.trim()
          : DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES.percent,
    };
  } catch {
    return { ...DEFAULT_TOKEN_TICKET_LADDER_PREFERENCES };
  }
}

export function writeTokenTicketLadderPreferences(
  preferences: TokenTicketLadderPreferences,
): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(
      TOKEN_TICKET_LADDER_PREFERENCES_KEY,
      JSON.stringify(preferences),
    );
  } catch {
    // Storage can be unavailable in private browsing or embedded contexts.
  }
}
